import { InsightService } from '@pepper/insights-react';
import SecurityService from '../services/Security';
import TokenService from '../services/TokenStorage';

export const authenticateToken = async (authToken: string): Promise<string> => {
  try {
    // Se codifica el token para que no se pierdan los caracteres especiales
    let encodedToken = encodeURIComponent(authToken).replace(
      new RegExp('%20', 'g'),
      '%2B'
    );
    const decodedToken = decodeURIComponent(encodedToken);

    // Se llama al servicio de autenticación y se almacena el access token recibido
    const tokenResponse = await SecurityService.authenticate(decodedToken);
    TokenService.setToken(tokenResponse.access_token);
    InsightService.logTrace('Token autenticado correctamente', [
      { Token: tokenResponse },
    ]);
    return tokenResponse.access_token;
  } catch (error) {
    return 'false';
  }
};
